import React, { useState, useRef, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Icons from "react-feather";
import { TextField, Loading, Select } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import { transformTranslateFromValues } from "lib/helpers";
import { Link, useNavigate } from "react-router-dom";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";
import AddSlide from "./AddSlide";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { useCore } from "store/core";
import { getCategories } from "store/core";
import { getCategoriesNew } from "store/core";
import { GalleryField } from "components/form";

// components

export default function Add(props) {
  const core = useCore();

  const path = {
    baseRoute: "/show-panel",
    aliasName: "صفحه ها",
    type: "Shows",
  };

  const navigator = useNavigate();
  const { dispatch, clear, create } = useList();
  const [slides, setSlides] = useState([]);
  const [showAddSlide, setShowAddSlide] = useState(false);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let temp_slides = arrayMoveImmutable(slides, oldIndex, newIndex);
    temp_slides = temp_slides.map((item, index) => ({ ...item, order: index }));
    setSlides(temp_slides);
  };

  useEffect(() => {
    dispatch(getCategoriesNew("filter[type][$eq]=News"));
    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      {/*add slide*/}
      <AddSlide
        slides={slides}
        setSlides={setSlides}
        show={showAddSlide}
        close={() => setShowAddSlide(false)}
        submit={(values) => {
          setSlides([...slides, values]);
        }}
      />
      {/*add slide*/}
      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد صفحه</h2>
          <Link to="/settings/Shows" className="btn btn-info shadow-md mr-2">
            بازگشت
          </Link>
        </div>

        <hr className="my-3" />
        <div className="p-3 w-full flex gap-x-2">
          <div className="w-1/4">
            <Formik
              initialValues={
                {
                  // media: null,
                }
              }
              onSubmit={async (values, { setSubmitting }) => {
                await dispatch(
                  create(path, { ...values, categories: slides }, () => {
                    handleSuccessMessages("عملیات با موفقیت انجام شد");
                    navigator("/settings/Shows");
                  })
                );
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({ isSubmitting, dirty }) => (
                <Form>
                  <div className="box rounded py-3">
                    <div className="p-3">
                      <div className="intro-x flex-col">
                        <Field
                          placeholder="صفحه"
                          label="صفحه :"
                          name="pageName"
                          component={TextField}
                          // validate={(value) =>
                          //   validationWrapper(value, required)
                          // }
                        />

                        {/* <Field
                          placeholder="سرعت صفحه (ثانیه)"
                          label="سرعت صفحه (ثانیه) :"
                          name="transition_speed"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required, number)
                          }
                        /> */}
                        {/* <div>
                          <Field
                            placeholder="نوع صفحه"
                            label="نوع صفحه :"
                            name="type"
                            component={Select}
                            validate={(value) =>
                              validationWrapper(value, required)
                            }
                            options={[
                              { value: "type_1", label: "نوع یک" },
                              { value: "type_2", label: "نوع دو" },
                              { value: "type_3", label: "نوع سه" },
                              { value: "type_4", label: "نوع چهار" },
                            ]}
                          />
                        </div> */}

                        <button
                          className="mt-4 btn btn-primary w-20"
                          type="submit"
                          disabled={!!(isSubmitting || !dirty)}
                        >
                          {isSubmitting ? <Loading /> : "ذخیره"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="w-3/4">
            <div className="box p-2">
              <div className="flex justify-between md:px-4 items-center">
                <h3>صفحه ها : </h3>
                <button
                  className="btn btn-primary btn-sm my-3"
                  onClick={() => {
                    setShowAddSlide(true);
                  }}
                >
                  ایجاد صفحه
                </button>
              </div>
              <hr className="my-2" />

              {/* slides List */}
              <div className="mt-3">
                <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report text-xs -mt-2">
                    <thead>
                      <tr>
                        <th className="whitespace-nowrap text-center w-16">
                          اولویت
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عنوان دسته
                        </th>

                        <th className="whitespace-nowrap text-center">
                          محل نمایش
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عملیات
                        </th>
                      </tr>
                    </thead>

                    {slides && slides?.length > 0 && (
                      <SortableList
                        items={slides}
                        onSortEnd={onSortEnd}
                        removeItem={(item) => {
                          setSlides(
                            slides?.filter((i) => i?.uuid != item?.uuid)
                          );
                        }}
                      />
                    )}
                  </table>
                </div>
              </div>
              {/* slides List */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SortableList = SortableContainer((props) => {
  const { items } = props;

  return (
    <tbody>
      {items?.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          removeItem={props.removeItem}
        />
      ))}
    </tbody>
  );
});
const SortableItem = SortableElement((props) => {
  const core = useCore();
  const { item } = props;

  const matchedCategory = core?.categories?.find(
    (category) => category?.value === item?.category
  );

  return (
    <tr className="intro-x cursor-pointer select-none">
      <td className="text-center">{item?.displayPriority}</td>

      <td className="text-center">
        {" "}
        {matchedCategory?.label.replace(/News/g, "").trim()} - {item?.type}
      </td>

      <td className="text-center">{item?.displayLocation}</td>

      <td className="text-center">
        <button
          className="flex items-center text-theme-6 cursor-pointer"
          onClick={() => props?.removeItem(item)}
        >
          <Icons.Trash2 className="w-4 h-4 ml-1 " />
          حذف
        </button>
      </td>
    </tr>
  );
});
